export interface PrintersManagementState {
  isRaspberrySoulConnected: boolean
  localPrinter: LocalPrinterData | undefined
  printers: PrinterData[]
}

export interface LocalPrinterData {
  macAddress: string
  localIp: string
  fulfillmentCenterId: number | undefined
  deviceName: string | undefined
  printerServer: boolean
  kdabraUrl: string | undefined
  features: RaspberryFeaturesEnum[] | undefined
}

export interface PrinterData {
  macAddress: string
  localIp: string
  fulfillmentCenter: string
  deviceName: string
  printerServer: boolean
  kdabraUrl: string
  lastActivity: Date
}

export interface SetProperty {
  property: keyof PrintersManagementState
  value: PrintersManagementState[keyof PrintersManagementState]
}

export enum RaspberryFeaturesEnum {
  TAG_CONFERECE_PRINT = 'IMPRESSAO_ETIQUETAS_CONFERENCIA',
  TAG_FRACTION_PRINT = 'IMPRESSAO_ETIQUETAS_FRACIONAMENTO'
}

export enum GenericApiErrors {
  Failed
}

export interface GetActivePrintersPayload {
  fulfillmentCenterId: number
  onSuccess: () => void
  onError: () => void
}

export interface SaveLocalPrinterSettingsPayload {
  fulfillmentCenterId: number
  kdabraUrl: string
  deviceName: string
  printerServer: boolean
  onSuccess: () => void
  onError: () => void
}

export interface CheckRemotePrinterHealthPayload {
  ip: string
  onSuccess: () => void
  onError: () => void
}
